import React from 'react'


const Services = () => {
  return (
    <>
    <h1 className='aboutme'>About Me</h1>
    <div className="info">Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure vero aliquid facere at ad saepe voluptatum labore voluptas voluptatem quasi suscipit sit perferendis, sapiente iste, dolores obcaecati eius odit! Nihil.Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure vero aliquid facere at ad saepe voluptatum labore voluptas voluptatem quasi suscipit sit perferendis, sapiente iste, dolores obcaecati eius odit! Nihil.</div>
    <div className="grids">
      <div className="grid">
        <p className="HeroText">Repairs</p>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur officia ipsam voluptate perspiciatis esse ex harum. Odio porro, autem, sit est at ad dolorum nulla sed facilis ipsa laborum quidem.</p>
      </div>
      <div className="grid">
      <p className="HeroText">Installation</p>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur officia ipsam voluptate perspiciatis esse ex harum. Odio porro, autem, sit est at ad dolorum nulla sed facilis ipsa laborum quidem.</p>
      </div>
      <div className="grid">
      <p className="HeroText">Painting</p>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur officia ipsam voluptate perspiciatis esse ex harum. Odio porro, autem, sit est at ad dolorum nulla sed facilis ipsa laborum quidem.</p>
      </div>
    </div>
    <div className="footer">
    <h1 className='aboutme color'>Contact Me!!</h1>
    <p className='footerp'><strong>Cell: 21491738217<br></br>
       Email: sajdhajdha@gmail.com</strong></p>
    </div>
    </>
  )
}

export default Services